import React, { useState } from 'react';
import {
  focusEditor,
  useEventPlateId,
  usePlateEditorState,
  getMarks,
  setMarks,
} from '@udecode/plate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ColorPicker from 'components/ColorPicker';
import ToolbarDropdown, { ToolbarDropdownButton } from './ToolbarDropdown';

import './table-dropdown.scss';

const BgColorDropdown = ({ id, colorPickerProps, ...props }) => {
  const { savedColors, usedColors, saveColor, deleteColor } = colorPickerProps || {};
  const editor = usePlateEditorState(useEventPlateId(id));
  const marks = getMarks(editor);
  const { backgroundColor } = marks || {};

  const [open, setOpen] = useState(false);

  const show = () => {
    setOpen(true);
  };

  const dismiss = () => {
    setOpen(false);
  };

  const trigger = (
    <ToolbarDropdownButton
      className="plate-toolbar__button toolbar-dropdown-button"
      {...props}
    >
      <FontAwesomeIcon icon={['fa', 'highlighter']} />
    </ToolbarDropdownButton>
  );

  const handleColorSelect = (e, value) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setMarks(editor, { backgroundColor: value });
    dismiss();
    focusEditor(editor);
  };

  const handleHexChange = (value) => {
    setMarks(editor, { backgroundColor: value });
    focusEditor(editor);
  };

  const handleColorSave = (e, value) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (saveColor) saveColor(value);
  };

  const handleSavedColorDelete = (e, value) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (deleteColor) deleteColor(value);
  };

  return (
    <ToolbarDropdown
      isOpen={open}
      show={show}
      dismiss={dismiss}
      DropdownButton={trigger}
      name="table-dropdown"
      tooltipName="Change background color"
      className="plate-toolbar__dropdown-button color-picker-dropdown"
      root={null}
    >
      <ColorPicker
        color={backgroundColor ?? 'none'}
        savedColors={savedColors}
        usedColors={usedColors}
        handleColorSelect={handleColorSelect}
        handleColorSave={handleColorSave}
        handleHexChange={handleHexChange}
        handleSavedColorDelete={handleSavedColorDelete}
        hasClearOption
      />
    </ToolbarDropdown>
  );
};

export default BgColorDropdown;
